import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import { Container } from "@mui/material";
import { Redirect } from "react-router-dom";
import { RootStateOrAny, useSelector } from "react-redux";
import { selectIsLoggedIn, ViewerState } from "@/Redux/Auth/AuthReducer";
import { selectAppCode } from "@/Redux/App/AppReducer";
import WebsiteAuthcodeForm from "@/Domains/AuthenticationManagement/WebsiteAuthcodeForm";

interface LoginMainProps {}

const useStyles = makeStyles()((theme) => ({
    container: {
        width: "100%",
        maxWidth: "100%",
        padding: "6px",
        minHeight: "100vh",
    },
}));

const WebsiteMainAppcodeView: FunctionComponent<
    LoginMainProps
> = (): JSX.Element => {
    const { classes } = useStyles();

    const isLoggedIn = useSelector((state) =>
        selectIsLoggedIn(state as ViewerState),
    );
    const appCode = useSelector((state) =>
        selectAppCode(state as RootStateOrAny),
    );

    if (isLoggedIn) {
        return <Redirect to="/manager" />;
    }

    if (appCode) {
        return <Redirect to="/login" />;
    }

    return (
        <Container fixed className={classes.container}>
            <WebsiteAuthcodeForm />
        </Container>
    );
};

export default WebsiteMainAppcodeView;
